import { render, staticRenderFns } from "./EnjoyPageTag.vue?vue&type=template&id=0aa99a68&scoped=true&"
import script from "./EnjoyPageTag.vue?vue&type=script&lang=js&"
export * from "./EnjoyPageTag.vue?vue&type=script&lang=js&"
import style0 from "./EnjoyPageTag.vue?vue&type=style&index=0&id=0aa99a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa99a68",
  null
  
)

export default component.exports